import { createSelector, Selector } from '@reduxjs/toolkit'
import { GlobalState } from 'store'
import { GlobalGridSettings } from 'store/grid/gridTypes'
import { gridStoreSelector } from './storeSelectors'

export const globalGridSettingsSelector: Selector<GlobalState, GlobalGridSettings> = createSelector(
  gridStoreSelector,
  gridStore => gridStore.global
)

export const showOnlyEnabledUsersSelector: Selector<GlobalState, boolean> = createSelector(globalGridSettingsSelector, globalGridSettings =>
  globalGridSettings.showOnlyEnabledUsers === undefined ? true : globalGridSettings.showOnlyEnabledUsers
)

export const showDraftMappingSelector: Selector<GlobalState, boolean> = createSelector(globalGridSettingsSelector, globalGridSettings =>
  globalGridSettings.showDraftMapping === undefined ? false : globalGridSettings.showDraftMapping
)
